import { Divider, Grid, Typography } from "@mui/material";
import CardActions from "src/pages/sistema/components/CardActions";
import { FieldView, SiNoChip } from "src/pages/sistema/components/FieldView";
import { OperacionADCMFields } from "../types/fields";
import { numberFormatter } from "src/utils/formatters/numberFormatter";

type SeccionADCMBridgeLoanProps = {
  operacion?: any;
}

const SeccionADCMBridgeLoan = ({ operacion }: SeccionADCMBridgeLoanProps) => {
  const operacionTieneBridgeLoan = operacion?.[OperacionADCMFields.Bridgeloan];
  const tieneGarantias = operacion?.[OperacionADCMFields.BridgeLoanGarantias];
  const esPrecancelable = operacion?.[OperacionADCMFields.BridgeLoanPrecancelable];

  if (!operacion || !operacionTieneBridgeLoan) return null;

  return (
    <CardActions title='Detalle de Bridge Loan' icon='mdi:bridge' colapsable>
      <Grid container spacing={2.5} rowSpacing={2.5}>
        <Grid item xs={12} >
          <FieldView label='Entidad Puente acreedora' value={operacion[OperacionADCMFields.BridgeLoanEntidadAcreedora]} />
        </Grid>
        {/* Condiciones financieras */}
        <Grid item xs={12} >
          <FieldView
            label='Monto'
            value={operacion[OperacionADCMFields.BridgeLoanMonto]
              ? numberFormatter.toStringWithAmount(operacion[OperacionADCMFields.BridgeLoanMonto], '$', 0)
              : undefined}
          />
        </Grid>
        <Grid item xs={12} >
          <FieldView label='Moneda' value={operacion[OperacionADCMFields.BridgeLoanMoneda]} />
        </Grid>

        <Grid item xs={12} >
          <FieldView label='Comisión estructuración' value={operacion[OperacionADCMFields.BridgeLoanComisionEstructuracion]} />
        </Grid>
        <Grid item xs={12} >
          <FieldView label='Tasa de interés' value={operacion[OperacionADCMFields.BridgeLoanTasaInteres]} />
        </Grid>
        <Grid item xs={12} >
          <FieldView label='Plazo' value={operacion[OperacionADCMFields.BridgeLoanPlazo]} />
        </Grid>
        <Grid item xs={12}>
          <FieldView label='Tipo de amortización capital' value={operacion[OperacionADCMFields.BridgeLoanTipoAmortizacionCapital]} />
        </Grid>
        <Grid item xs={12} >
          <FieldView label='Frecuencia pago interés' value={operacion[OperacionADCMFields.BridgeLoanFrecuenciaPagoInteres]} />
        </Grid>

        {/* Garantías */}
        <Grid item xs={12}>
          <Divider textAlign='left'>
            <Typography variant='caption' color='text.secondary' sx={{ textTransform: 'uppercase', letterSpacing: '0.08em' }}>
              Garantías
            </Typography>
          </Divider>
        </Grid>
        <Grid item xs={4} >
          <FieldView label='Garantías'>
            <SiNoChip value={operacion[OperacionADCMFields.BridgeLoanGarantias]} />
          </FieldView>
        </Grid>
        {tieneGarantias && (
          <>
            <Grid item xs={12}>
              <FieldView label='Detalle garantías' value={operacion[OperacionADCMFields.BridgeLoanDetalleGarantias]} />
            </Grid>
            <Grid item xs={12} >
              <FieldView label='Detalle aforo' value={operacion[OperacionADCMFields.BridgeLoanDetalleAforo]} />
            </Grid>
          </>
        )}

        {/* Precancelación */}
        <Grid item xs={12}>
          <Divider textAlign='left'>
            <Typography variant='caption' color='text.secondary' sx={{ textTransform: 'uppercase', letterSpacing: '0.08em' }}>
              Precancelación
            </Typography>
          </Divider>
        </Grid>
        <Grid item xs={4} >
          <FieldView label='Precancelable'>
            <SiNoChip value={operacion[OperacionADCMFields.BridgeLoanPrecancelable]} />
          </FieldView>
        </Grid>
        {esPrecancelable && (
          <Grid item xs={12} md={9}>
            <FieldView label='Condiciones precancelación' value={operacion[OperacionADCMFields.BridgeLoanCondicionesPrecancelacion]} />
          </Grid>
        )}

      </Grid>
    </CardActions>
  );
};

export default SeccionADCMBridgeLoan;
